import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  // name: {
  //   name: "name",
  //   label: "Name",
  //   type: "text",
  //   errorMsg: "Name is required.",
  //   required: true,
  //   maxLength: 50,
  // },
  team: {
    name: "team",
    label: "Team",
    type: "text",
    errorMsg: "Team is required.",
    required: true,
  },
  customerCode: {
    name: "customerCode",
    label: "Customer Code",
    type: "select",
    errorMsg: "Customer is required.",
    required: true,
  },
  productivity: {
    name: "productivity",
    label: "Productivity Range",
    type: "select",
    errorMsg: "Productivity Range is required.",
    required: true,
  },
  user: {
    name: "user",
    label: "User Range",
    type: "select",
    errorMsg: "User Range is required.",
    required: true,
  },
  // state: {
  //   name: "state",
  //   label: "State",
  //   type: "select",
  // },
  // postcode: {
  //   name: "postcode",
  //   label: "Postcode",
  //   type: "text",
  // },
  // country: {
  //   name: "country",
  //   label: "Country",
  //   type: "select",
  // },
};

const { team,customerCode ,productivity,user } = formField;

export const formRender = [[team], [customerCode],[productivity],[user]];

export const initialValues = getInitialValues(formField);

export const kpiTeamValidation = Yup.object().shape({
  // [name.name]: Yup.string().nullable().max(name.maxLength).required(name.errorMsg),
  [team.name]: Yup.string().nullable().required(team.errorMsg),
  //[customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
  [productivity.name]: Yup.mixed().nullable().required(productivity.errorMsg),
  [user.name]: Yup.mixed().nullable().required(user.errorMsg),
});
